import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

import { onErrorCaptured, ref, watch } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  ...{
  name: 'ErrorBoundary',
},
  __name: 'ErrorBoundary',
  setup(__props) {



const error = ref(false);
const route = useRoute();

onErrorCaptured((err) => {
  console.error('ErrorBoundary caught an error:', err);
  error.value = true;
  return false;
});

watch(
  () => route.fullPath,
  () => {
    error.value = false;
  },
);

function reload() {
  window.location.reload();
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_result = _resolveComponent("a-result")!

  return (error.value)
    ? (_openBlock(), _createBlock(_component_a_result, {
        key: 0,
        status: "error",
        title: "Something went wrong",
        "sub-title": "Please try refreshing the page."
      }, {
        extra: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: reload
          }, {
            default: _withCtx(() => [
              _createTextVNode("Reload page")
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})